import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded'
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded'
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded'
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded'
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded'
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded'
import SettingsEthernetRoundedIcon from '@mui/icons-material/SettingsEthernetRounded'
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded'

const support = {
  id: 'administration',
  title: 'Administration',
  type: 'group',
  children: [
    {
      id: 'billing',
      title: 'Billing',
      type: 'item',
      icon: AttachMoneyRoundedIcon,
      url: '/billing',
      requirements: {
        componentId: 'NavItem__Billing',
        auth: true,
        endpoints: [{ method: 'GET', path: '/user' }],
        uiPermission: 'billing:view'
      }
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      icon: TrendingUpRoundedIcon,
      url: '/reports',
      requirements: {
        componentId: 'NavItem__Reports',
        auth: true,
        endpoints: [{ method: 'GET', path: '/user' }],
        uiPermission: 'reports:view'
      }
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'collapse',
      icon: SettingsRoundedIcon,
      requirements: {
        componentId: 'NavItem__Settings',
        auth: true,
        endpoints: [{ method: 'GET', path: '/user' }],
        uiPermission: 'settings:view'
      },
      children: [
        {
          id: 'users',
          title: 'Users',
          type: 'item',
          url: '/users',
          icon: PeopleRoundedIcon,
          requirements: {
            componentId: 'NavItem__Users',
            auth: true,
            endpoints: [{ method: 'GET', path: '/users' }],
            uiPermission: 'users:view'
          }
        },
        {
          id: 'facilities',
          title: 'Facilities',
          type: 'item',
          url: '/facilities',
          icon: HomeWorkRoundedIcon,
          requirements: {
            componentId: 'NavItem__Facilities',
            auth: true,
            endpoints: [{ method: 'GET', path: '/facilities' }],
            uiPermission: 'facilities:view'
          }
        },
        {
          id: 'companies',
          title: 'Companies',
          type: 'item',
          url: '/companies',
          icon: BusinessCenterRoundedIcon,
          requirements: {
            componentId: 'NavItem__Companies',
            auth: true,
            endpoints: [{ method: 'GET', path: '/user' }],
            uiPermission: 'settings:manage'
          }
        },
        {
          id: 'ediConfigs',
          title: 'UB-04 Config',
          type: 'item',
          url: '/edi-configs',
          icon: SettingsEthernetRoundedIcon,
          requirements: {
            componentId: 'NavItem__EdiConfigs',
            auth: true,
            endpoints: [{ method: 'GET', path: '/edi-configs' }],
            uiPermission: 'edi:manage'
          }
        },
        {
          id: 'roles',
          title: 'Roles',
          type: 'item',
          url: '/roles',
          icon: SecurityRoundedIcon,
          requirements: {
            componentId: 'NavItem__Roles',
            auth: true,
            endpoints: [{ method: 'GET', path: '/roles' }],
            uiPermission: 'settings:manage'
          }
        }
      ]
    }
  ]
}

export default support
